import { RB_ROUTES } from '@localstack/constants';

export const RESOURCES_TYPES = {
  lambda: RB_ROUTES.RESOURCES_LAMBDA_FUNCTIONS,
  'cognito-idp': RB_ROUTES.RESOURCES_COGNITO,
  'cognito-identity': RB_ROUTES.RESOURCES_COGNITO_IDENTITY_POOLS,
  cloudformation: RB_ROUTES.RESOURCES_CLOUDFORMATION_STACKS,
  apigateway: RB_ROUTES.RESOURCES_AGW1,
  apigatewayv2: RB_ROUTES.RESOURCES_AGW2,
  appsync: RB_ROUTES.RESOURCES_APPSYNC,
  logs: RB_ROUTES.RESOURCES_CLOUDWATCH_GROUPS,
  cloudwatch: RB_ROUTES.RESOURCES_CLOUDWATCH_MONITORING,
  dynamodb: RB_ROUTES.RESOURCES_DYNAMODB,
  sqs: RB_ROUTES.RESOURCES_SQS_QUEUES,
  sns: RB_ROUTES.RESOURCES_SNS_TOPICS,
  s3: RB_ROUTES.RESOURCES_S3,
  stepfunctions: RB_ROUTES.RESOURCES_STEPFUNCTIONS,
  athena: RB_ROUTES.RESOURCES_ATHENA_DATABASES,
  ses: RB_ROUTES.RESOURCES_SES1_IDENTITIES,
  sesv2: RB_ROUTES.RESOURCES_SES2_IDENTITIES,
  ssm: RB_ROUTES.RESOURCES_SYSTEM_PARAMETERS,
  cloudtrail: RB_ROUTES.RESOURCES_CLOUDTRAIL_EVENTS,
  'timestream-write': RB_ROUTES.RESOURCES_TIMESTREAM,
  rds: RB_ROUTES.RESOURCES_RDS_DATABASES,
  secretsmanager: RB_ROUTES.RESOURCES_SECRETS_MANAGER,
  events: RB_ROUTES.RESOURCES_EVENT_BRIDGE,
  kms: RB_ROUTES.RESOURCES_KMS,
  kinesis: RB_ROUTES.RESOURCES_KINESIS,
  kafka: RB_ROUTES.RESOURCES_KAFKA,
  iam: RB_ROUTES.RESOURCES_IAM,
  elasticache: RB_ROUTES.RESOURCES_ELASTICACHE,
  backup: RB_ROUTES.RESOURCES_BACKUP_PLANS,
  ecs: RB_ROUTES.RESOURCES_ECS,
  ec2: RB_ROUTES.RESOURCES_EC2,
  ecr: RB_ROUTES.RESOURCES_ECR_REPOSITORIES,
  glue: RB_ROUTES.RESOURCES_GLUE,
  mq: RB_ROUTES.RESOURCES_MQ_BROKERS,
  sagemaker: RB_ROUTES.RESOURCES_SGM_MODELS,
  'application-autoscaling': RB_ROUTES.RESOURCES_APPLICATION_AUTO_SCALING,
  cloudfront: RB_ROUTES.RESOURCES_CLOUDFRONT_DISTRIBUTIONS,
  route53: RB_ROUTES.RESOURCES_ROUTE53,
  neptune: RB_ROUTES.RESOURCES_NEPTUNE_INSTANCES,
  elb: RB_ROUTES.RESOURCES_EC2_LBV1,
  elbv2: RB_ROUTES.RESOURCES_EC2_LBV2,
  opensearch: RB_ROUTES.RESOURCES_OPENSEARCH_DOMAINS,
  docdb: RB_ROUTES.RESOURCES_DOCDB_CLUSTERS,
  appconfig: RB_ROUTES.RESOURCES_APPCONFIG_APPLICATIONS,
  acm: RB_ROUTES.RESOURCES_ACM_CERTIFICATES,
  mwaa: RB_ROUTES.RESOURCES_MWAA_ENVIRONMENTS,
  amplify: RB_ROUTES.RESOURCES_AMPLIFY_APPS,
  eks: RB_ROUTES.RESOURCES_EKS_CLUSTERS,
  transcribe: RB_ROUTES.RESOURCES_TRANSCRIBE_TRANSCRIPTION_JOBS,
  codecommit: RB_ROUTES.RESOURCES_CODECOMMIT_REPOSITORIES,
  ce: RB_ROUTES.RESOURCES_CE_COST_CATEGORY_DEFINITIONS,
  account: RB_ROUTES.RESOURCES_ACCOUNT_CONTACTINFO,
  dms: RB_ROUTES.RESOURCES_DMS_REPLICATION_INSTANCES,
  pipes: RB_ROUTES.RESOURCES_EVENT_BRIDGE_PIPES,
  redshift: RB_ROUTES.RESOURCES_REDSHIFT_CLUSTERS,
  firehose: RB_ROUTES.RESOURCES_FIREHOSE_STREAMS,
};

export type ResourceGroups = [string, (keyof typeof RESOURCES_TYPES)[]][][];

// try to keep more or less the same number of services under each column
export const RESOURCE_GROUPS: ResourceGroups = [
  [
    [
      'App Integration',
      ['apigateway', 'sqs', 'sns', 'stepfunctions', 'events', 'application-autoscaling', 'mwaa', 'mq', 'pipes'],
    ],
    ['Compute', ['ec2', 'lambda', 'ecs', 'ecr', 'eks']],
  ],
  [
    ['Management/Governance', ['cloudformation', 'logs', 'cloudwatch', 'ssm', 'cloudtrail', 'account']],
    ['Business Applications', ['ses']],
    ['Developer Tools', ['appconfig', 'codecommit']],
    ['Front-end Web & Mobile', ['appsync', 'amplify']],
    ['Migration and transfer', ['dms']],
  ],
  [
    ['Security Identity Compliance', ['cognito-idp', 'secretsmanager', 'kms', 'iam', 'acm']],
    ['Storage', ['s3', 'backup']],
    ['Machine Learning', ['sagemaker', 'transcribe']],
    ['Cloud Financial Management', ['ce']],
  ],
  [
    ['Database', ['dynamodb', 'rds', 'elasticache', 'timestream-write', 'docdb', 'neptune']],
    [
      'Analytics',
      ['athena', 'kinesis', 'firehose', 'kafka', 'glue', 'route53', 'cloudfront', 'opensearch', 'redshift'],
    ],
  ],
];

export const DEFAULT_CLIENT_OVERRIDES = {};
